
(function() {
  var minSlider = document.getElementById("priceSliderMin");
  var maxSlider = document.getElementById("priceSliderMax");
  var track = document.getElementById("priceTrack");
  var minShow = document.getElementById("priceMinShow");
  var maxShow = document.getElementById("priceMaxShow");
  var applyBtn = document.getElementById("priceApplyBtn");

  if (!minSlider || !maxSlider) return;

  var rMin = parseFloat(minSlider.min);
  var rMax = parseFloat(minSlider.max);

  function update() {
    var lo = parseFloat(minSlider.value);
    var hi = parseFloat(maxSlider.value);
    if (lo > hi) { var t = lo; lo = hi; hi = t; }
    var left = ((lo - rMin) / (rMax - rMin)) * 100;
    var right = ((rMax - hi) / (rMax - rMin)) * 100;
    if (track) { track.style.left = left + "%"; track.style.right = right + "%"; }
    if (minShow) minShow.textContent = Math.round(lo);
    if (maxShow) maxShow.textContent = Math.round(hi);
  }

  minSlider.addEventListener("input", update);
  maxSlider.addEventListener("input", update);

  if (applyBtn) {
    applyBtn.addEventListener("click", function() {
      var lo = parseFloat(minSlider.value);
      var hi = parseFloat(maxSlider.value);
      if (lo > hi) { var t = lo; lo = hi; hi = t; }

      var url = new URL(window.location.href);
      var params = new URLSearchParams();
      url.searchParams.forEach(function(v, k) {
        if (!k.includes("price")) params.append(k, v);
      });

      /* Pass the value as-is - no conversion needed */
      params.set(minSlider.dataset.param, Math.round(lo));
      params.set(maxSlider.dataset.param, Math.round(hi));

      window.location.href = url.pathname + "?" + params.toString();
    });
  }

  update();
})();
